import React, { useState, useRef, useEffect } from "react";
import "../assets/css/bootstrap-grid.css";
// import "../assets/css/innkeyPMS.css";
import styles from "../assets/css/dropdown.css";
import DownArrow from "../assets/images/down-arrow.svg";
import UpArrow from "../assets/images/up-arrow.svg";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { width } from "@mui/system";

export function InnSingleSelectDropdown(props) {

  const [isPageLoaded,setIsPageLoaded] = useState(true);

  const [isListOpen, setisListOpen] = useState(false);

  const [keyword, setkeyword] = useState("");
  const [inputErrors, setinputErrors] = useState(false);
  const [errorMessage, seterrorMessage] = useState(false);
  const [errorString, seterrorString] = useState("");
  const [selected, setselected] = useState("");
  const [clientWidth, setclientWidth] = useState(0);

  //reference varible for searching field start
  const searchField = useRef(null);
  const btnRef = useRef(null);

  //For Open Close Dropdown start
  const toggleList = () => {    
    setisListOpen(true);
    setkeyword("");    
    //for search functionality toggle event
    if (isListOpen && searchField.current) {
      searchField.current.focus();
      setkeyword("");
    }
    if (isListOpen == false) {      
      setclientWidth(btnRef.current.clientWidth);
      if (selected) {
        try{
          setTimeout(() => {
            const elementToScroll = document.getElementsByClassName(`dd-list-item active ${selected}`);
            const scrollControl = document.getElementsByClassName(`dd-scroll-list ${props.id}`);  
            if (elementToScroll != undefined && scrollControl != undefined){
              if (elementToScroll.length > 0 && scrollControl.length > 0){
                scrollControl[0].scrollTop = elementToScroll[0].offsetTop - 60;  
              }
            }
          }, 10);
        }        
        catch(ex){

        }
      }
    }
  };
  //For Open Close Dropdown End

  //For Display ListItems Start
  const listItems = () => {
    let tempList = [...props.list];

    if (keyword.length) {
      //check the keyword is match to key or not
      tempList = props.list.filter((item) =>
        item.value.toLowerCase().includes(keyword.toLowerCase())
      );
    }

    if (tempList.length > 0) {
      return tempList.map((item) => (
        <button
          type="button"
          className={
            item.value == selected ? `dd-list-item active ${item.value}` : `dd-list-item ${item.value}`
          }
          style={styles.listItem}
          key={item.key}
          id={item.value} //props.id
          onClick={(e) => selectItem(item,e)}
        >
          {item.value}
        </button>
      ));
    }

    return (
      <div className={`dd-list-item no-result`} style={styles.listItemNoResult}>
        {props.searchable && props.searchable[1]}
      </div>
    );
  };
  //For Display ListItems End

  //For TextBox Search Function start
  const filterList = (e) => {
    setkeyword(e.target.value.toLowerCase());
  };
  //For TextBox Search Function End

  //For Close Dropdown Start
  const close = () => {
    setisListOpen(false);
  };
  //For Close Dropdown End

  useEffect(() => {
    window.removeEventListener("click", close);
    return () => {
      window.removeEventListener("click", close);
    };
  }, [isListOpen]);

  useEffect(() => {
    setTimeout(() => {
      if (isListOpen) {
        window.addEventListener("click", close);
      } else {
        window.removeEventListener("click", close);
      }
    }, 0);
  }, [isListOpen]);

  //For Display Selected Items
  const selectItem = (item,e) => {
    let foundItem;
    let tempList = [...props.list];    
    if (item) {
      if (!item.key) {
        foundItem = tempList.find((i) => i.value == item.value);
      }
      setselected(item.value);      

      // console.log("is page loaded ",isPageLoaded);

      if(!isPageLoaded){
        if (props.onChange != undefined){
          props.onChange(item,e);
          close();
        } 
      }      

      if (item == null || item == undefined) {
        seterrorMessage(true);
        seterrorString(props.customError);
        setinputErrors(true);
      } else {
        seterrorMessage(false);
        seterrorString("");
        setinputErrors(false);
      }
    }
  };

  const selectSingleItem = (item) => {
    let tempList = [...props.list];
    
    // comment by ketan on 24th nov 22 due to not using value as unique id
    // if (item && props.list) {
    //   const selectedItem = tempList.find((i) => i.value == item);
    //   selectItem(selectedItem);
    // }

    if (item && props.list && props.selectedSerNo) {
      const selectedItem = tempList.find((i) => i.key == props.selectedSerNo);
      selectItem(selectedItem);
    }

    // comment by ketan on 24th nov 22 due to not using select as a object 
    // if (item && props.list && props.select) {
    //   const selectedItem = tempList.find((i) => i == props.select);
    //   selectItem(selectedItem);
    // }
  };

  //only one time call useeffect start
  useEffect(() => {

    // comment by ketan on 24th nov 22 due to not using select as a object 
    // if (props.select) {
    //   setselected(props.select);
    // } else {
    //   setselected([]);
    // }
    // //for unique key
    if (props.selectedSerNo) {
      const obj = props.list.find((f) => f.key == selected);
      if (obj) {
        //setselected(props.selectedSerNo);
        setselected(obj.value);
      }
    } else {
      setselected([]);
    }
    
    // comment by ketan on 24th nov 22 due to not using select as a object 
    // if (props.select) {
    //   selectSingleItem(props.select);
    // }
    //for unique key
    if (props.selectedSerNo) {
      selectSingleItem(props.selectedSerNo);
    }
    setIsPageLoaded(false);
  }, []);
  //only one time call useeffect end

  //// comment by ketan on 24th nov 22 due to not using select as a object 
  // useEffect(() => {
  //   let tempList = [...props.list];
  //   if (props.select != selected) {
  //     const obj = tempList.find((f) => f == props.select);

  //     if (obj) {
  //       setselected(props.select);
  //     }
  //   }
  // }, [props.select]);

  useEffect(() => {
    let tempList = [...props.list];
    if (selected != undefined) {
      if (props.selectedSerNo != selected) {
        const obj = tempList.find((f) => f.key == props.selectedSerNo);

        if (obj) {
          setselected(obj.value);
        }
      }
    }
  }, [props.selectedSerNo]);

  //for customerror useeffect start
  useEffect(() => {
    if (props.customError && props.customError.length > 0) {
      setinputErrors(true);
      seterrorMessage(true);
      seterrorString(props.customError);
    } else {
      setinputErrors(false);
      seterrorMessage(false);
      seterrorString("");
    }
  }, [props.customError]);
  //for customerror useeffect end

  useEffect(() => {
    if (props.selectedSerNo != undefined) {
      let obj = props.list.find((f) => f.key == props.selectedSerNo);
      if (obj) {
        setselected(obj.value);
      }
    } else {
      setselected([]);
    }
  }, [props.list]);

  return (
    <Tippy
      content={
        isListOpen && (
          <div>
            {props.searchable && (
              <input
                type="text"
                ref={searchField}
                className={`dd-list-search-bar ${props.id}`}
                style={styles.listSearchBar}
                placeholder={props.searchable[0]}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => filterList(e)}
              />
            )}
            <div
              className={`dd-scroll-list ${props.id}`}
              // style={styles.scrollList}
              style={{ minWidth: clientWidth }}
              id={`scroll ${props.id}`}
            >
              {listItems()}
            </div>
          </div>
        )
      }
      // trigger="click"
      arrow={false}
      allowHTML={true}
      interactive={true}
      appendTo={document.body}
      visible={isListOpen}
      placement="bottom-start"
    >
      <div className={props.disabled == true ? "disabled" : ""}>
        <h5>{props.label}</h5>
        <div className={`dd-wrapper ${props.id}`} style={styles.wrapper}>
          <button
            type="button"
            className={`dd-header ${props.id}`}
            onClick={toggleList}
            style={styles.header}
            disabled={props.disabled}
            ref={btnRef}
          >
            <div
              className={`dd-header-title ${props.id}`}
              style={styles.headerTitle}
            >
              {/* {selected ? selected.value : ""} */}
              {selected ? selected : ""}
            </div>
            {isListOpen ? (
              <span>
                <img src={UpArrow} />
              </span>
            ) : (
              <span>
                <img src={DownArrow} />
              </span>
            )}
          </button>
        </div>
        {inputErrors == true && errorMessage == true ? (
          <div class="error">
            <span>{errorString}</span>
          </div>
        ) : (
          <></>
        )}
      </div>
    </Tippy>
  );
}
